<template>
  <div class="walletModal__overlay" @click="exitModal"></div>
  <transition name="slide" appear>
    <div class="modal">
      <p>{{ modalPrompt }}</p>
      <div class="wallet-provider" @click="handleMetaMask">
        <p><span v-if="!ethereum.hasLocalProvider">Get</span> MetaMask</p>
        <img src="../../images/metamask-icon.svg" />
      </div>
      <br><br>
      <div class="wallet-provider" @click="handleWalletConnect">
        <p><span v-if="!ethereum.hasLocalProvider">Get</span> WalletConnect</p>
        <img src="../../images/walletconnect-logo.svg" />
      </div>
    </div>
  </transition>
</template>

<script>
'use strict';

// Imports.
import { mapState } from 'vuex';
import store from '../../store';

// Set up the default component.
export default {
  emits: ['exit'],

  data() {
    return {
      show: true
    };
  },

  computed: {
    ...mapState({
      ethereum: state => state.ethers
    }),
    modalPrompt() {
      return 'Connect to your Wallet';
    }
  },

  methods: {
    async handleMetaMask() {
      if (this.ethereum.hasLocalProvider) {
        await store.dispatch('ethers/connectWallet', '', { root: true });
        this.$emit('exit');
        // If there is no local Ethereum provider, this button should direct the
        // user to install MetaMask.
      } else {
        window.open('https://www.metamask.io', '_blank');
      }
    },
    async handleWalletConnect() {
      await store.dispatch('ethers/connectWCProvider', '', { root: true });
      this.$emit('exit');
    },
    exitModal() {
      this.$emit('exit');
    }
  }
};
</script>

<style scoped>
.walletModal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 98;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  width: 400px;
  padding: 40px;
  background-color: black;
  color: white;
  /* border: 1px solid white; */
  border-radius: 24px;
}

.modal > p {
  margin-bottom: 32px;
  font-size: 24px;
  line-height: 1.3em;
  font-weight: 600;
  text-align: center;
}

.wallet-provider {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  background-color: black;
  transition: box-shadow 200ms ease;
  font-size: 16px;
  font-weight: 500;
  color: #f6851a;
  height: 70px;
  padding: 15px 25px;
}

.wallet-provider:hover {
  cursor: pointer;
  box-shadow: 0 8px 15px 0 rgba(255, 255, 255, 0.25);
}

.wallet-provider:active {
  box-shadow: none;
}

.slide-enter-active {
  transition: opacity 0.5s ease;
}

.slide-enter-from,
.slide-leave-active {
  opacity: 0;
}
</style>
